/* v8 ignore start */

import Alpine from "alpinejs";
import guidesFormModal from "./guides-form-modal";
// tipsForm removed — registered only in tips.mjs to avoid loading it on every page
import alpineData from "./alpine-body-data";
import cookiesModal from './cookies-modal';

Alpine.data('guideFormModal', guidesFormModal);
Alpine.data('alpineBodyData', alpineData);
Alpine.data('cookiesModal', cookiesModal);

window.Alpine = Alpine;

// Export Alpine instead of starting it immediately
export default Alpine;

/* v8 ignore end */
